import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/crm/contacts')({
  component: ContactsLayout,
})

function ContactsLayout() {
  return <Outlet />
}
